// Shared query-key prefixes, extracted so composables can invalidate each other without circular imports.
export const WHO_AM_I_QUERY_KEY = ['restricted', 'whoAmI'] as const;
